export * from './reset-password.component';



// WEBPACK FOOTER //
// ./src/app/login/reset-password/index.ts